import { Promise } from 'es6-promise';
import callApi, { setCookie, getCookie } from '../../util/apiCaller';
import { resetTVCollectorMappings, resetTVProductMappings } from '../Setup/SetupActions';
import { resetTVPrograms } from '../Nomination/NominationActions';
// Export Constants
export const LOGIN = 'LOGIN';
export const LOGIN_USERS = 'LOGIN_USERS';
export const LOGIN_ERRORS = 'LOGIN_ERRORS';
export const PRETENT_ORGANIZATION = 'PRETENT_ORGANIZATION';
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const ORGANIZATION_MANAGERS = 'ORGANIZATION_MANAGERS';

export const POSTMARK_FETCH_SIGNATURE = 'POSTMARK_FETCH_SIGNATURE';
export const POSTMARK_SEND_SIGNATURE_CONFIRMATION = 'POSTMARK_SEND_SIGNATURE_CONFIRMATION';

export const FETCH_COLLECTOR_LANGUAGE_MAPPINGS = 'FETCH_COLLECTOR_LANGUAGE_MAPPINGS';
export const SHOW_COLLECTOR_LANGUAGE_MAPPING_MODAL = 'SHOW_COLLECTOR_LANGUAGE_MAPPING_MODAL';

export const UPDATE_EMAIL_ALERT_SUBSCRIPTION = 'UPDATE_EMAIL_ALERT_SUBSCRIPTION';


// Export Actions
export function login(user) {
  return {
    type: LOGIN,
    user,
  };
}

export function addAllUsers(users) {
  return {
    type: LOGIN_USERS,
    users,
  };
}

export function loginErrors(errors) {
  return {
    type: LOGIN_ERRORS,
    errors,
  };
}

export function loginWithCodeRequest(serviceType, params) {
  return (dispatch) => {
    dispatch(loginErrors({}));
    const uri = `auth/${serviceType.includes('hubspot') ? 'hubspot' : serviceType}`;
    return callApi(uri, 'POST', params, false).then(
      (res) => {
        if (serviceType === 'hubspotlogin' && res.user.is_synchronization_user) {
          return Promise.resolve(res.user);
        } else {
          setCookie(res.user.$token);
          return dispatch(login(res.user));
        }
      },
      (errors) => {
        const e = errors.data ? errors.data.error || errors.data : errors;
        dispatch(loginErrors(e));
        return Promise.reject(e);
      },
    );
  };
}

export function clearLoginErrors() {
  return (dispatch) => {
    return dispatch(loginErrors({}));
  };
}

export function loginWithEmailAndPassword(username, password) {
  return (dispatch) => {
    dispatch(loginErrors({}));
    return callApi('login', 'POST', { username, password }, false).then(
      (res) => {
        setCookie(res.user.$token);
        return dispatch(login(res.user));
      },
      (errors) => {
        const e = errors.data ? errors.data.error || errors.data : errors;
        dispatch(loginErrors(e));
        return Promise.reject(e);
      },
    );
  };
}


export function checkUsername(username, organizationId) {
  return (dispatch) => {
    dispatch(loginErrors({}));
    const p = callApi('login/check-username', 'POST', { username, organizationId }, false).then(
      (res) => {
        // return dispatch(login(res.user));
        return Promise.resolve(res);
      },
      (errors) => {
        const e = errors.data ? errors.data.error || errors.data : errors;
        dispatch(loginErrors(e));
        return Promise.reject(e);
      },
    );
    return p;
  };
}


export function resetPassword(password) {
  return dispatch => callApi('password', 'PUT', { password }).then(
    (res) => {
      setCookie(res.user.$token);
      return dispatch(login(res.user));
    },
    (errors) => {
      const e = errors.data ? errors.data.error || errors.data : errors;
      return Promise.reject(e);
    },
  );
}

export function getUserFromCookie() {
  const c = getCookie();
  if (c) {
    setCookie(c);
    return callApi('me');
  }
  return Promise.reject('No cookie');
}

export function loginFromCookieRequest() {
  return (dispatch) => {
    const p = getUserFromCookie();
    p.then(
      res => dispatch(login(res.user)),
      () => {
        setCookie(null);
        return dispatch(login({}));
      },
    );
    return p;
  }
}


export function requestUpdateLoginTimestamp() {
  return () => callApi('auth/log', 'GET').then(
    res => Promise.resolve(res.user),
    (errors) => {
      const e = errors.data ? errors.data.error || errors.data : errors;
      return Promise.reject(e);
    },
  );
}

export function logout() {
  return (dispatch) => {
    const p = callApi('auth/logout', 'POST');
    p.then(
      () => {
        setCookie(null);
        dispatch(login({}));
      },
      () => {
        setCookie(null);
        dispatch(login({}));
      },
    );
    return p;
  };
}

export function requestFetchUsers() {
  return dispatch => callApi('auth/users', 'GET').then(res => dispatch(addAllUsers(res.users)));
}


export function requestHijack(id) {
  return dispatch => callApi('auth/hijack', 'POST', { id }).then((res) => {
    setCookie(res.user.$token);
    dispatch(login(res.user));
    return res.user;
  });
}


export function setPretentOrganization(organization) {
  return {
    type: PRETENT_ORGANIZATION,
    organization,
  };
}
export function requestPretentOrganization(id) {
  return (dispatch) => {
    const p = callApi('auth/pretent', 'PUT', { id });
    p.then((res) => {
      dispatch(setPretentOrganization(res.organization));
      resetTVProductMappings()(dispatch);
      resetTVCollectorMappings()(dispatch);
      resetTVPrograms()(dispatch);
    });
    return p;
  };
}

export function searchOrganization(params = {}) {
  return () => callApi('organizations', 'GET', params);
}


export function requestRemind(email) {
  return () => callApi('remind', 'POST', { email }, false).then(
    result => Promise.resolve(result),
    (errors) => {
      const e = errors.data ? errors.data.error || errors.data : errors;
      return Promise.reject(e);
    },
  );
}


export function requestResetPassword(password, token) {
  return () => callApi('reset', 'POST', { password, token }, false).then(
    result => Promise.resolve(result),
    (errors) => {
      const e = errors.data ? errors.data.error || errors.data : errors;
      return Promise.reject(e);
    },
  );
}

export function addOrganizationManagers(managers) {
  return {
    type: ORGANIZATION_MANAGERS,
    managers,
  };
}
export function fetchOrganizationManagers(params = {}) {
  return (dispatch) => {
    const p = callApi('managers', 'GET', params);
    p.then((res) => {
      dispatch(addOrganizationManagers(res.managers));
    });
    return p;
  };
}

export function listManagers(params = {}) {
  return () => {
    const p = callApi('list-managers', 'GET', params);
    return p;
  };
}

export function fetchManager() {
  return () => {
    const p = callApi('manager', 'GET');
    return p;
  };
}

export function fetchPostmarkSignature() {
  return (dispatch) => {
    const p = callApi('postmark/signature', 'GET');
    p.then(
      ({ signature }) => dispatch({ type: POSTMARK_FETCH_SIGNATURE, signature }),
      errors => dispatch({ type: POSTMARK_FETCH_SIGNATURE, signature: null, errors }),
    );
    return p;
  };
}

export function createPostmarkSignature() {
  return (dispatch) => {
    const p = callApi('postmark/signature', 'POST');
    p.then(
      ({ signature }) => dispatch({ type: POSTMARK_FETCH_SIGNATURE, signature }),
      errors => dispatch({ type: POSTMARK_FETCH_SIGNATURE, signature: null, errors }),
    );
    return p;
  };
}

export function resendPostmarkConfirmation() {
  return (dispatch) => {
    const p = callApi('postmark/signature/resend-confirmation', 'POST');
    p.then(
      results => dispatch({ type: POSTMARK_SEND_SIGNATURE_CONFIRMATION, ...results }),
      errors => dispatch({ type: POSTMARK_SEND_SIGNATURE_CONFIRMATION, errors }),
    );
    return p;
  };
}

export function fetchUserInfo() {
  return dispatch => callApi('me').then(({ user }) => {
    dispatch({
      type: FETCH_USER_INFO,
      user,
    });
  });
}


export function showCollectorLanguageMappingModal() {
  return dispatch => dispatch({
    type: SHOW_COLLECTOR_LANGUAGE_MAPPING_MODAL,
    showModal: true,
  });
}

export function hideCollectorLanguageMappingModal() {
  return dispatch => dispatch({
    type: SHOW_COLLECTOR_LANGUAGE_MAPPING_MODAL,
    showModal: false,
  });
}

export function fetchCollectorLanguageMappings() {
  return (dispatch) => {
    const p = callApi('me/collector-languages');
    p.then(
      mappings => dispatch({ type: FETCH_COLLECTOR_LANGUAGE_MAPPINGS, mappings, errors: null }),
      errors => dispatch({ type: FETCH_COLLECTOR_LANGUAGE_MAPPINGS, mappings: [], errors }),
    );
    return p;
  };
}

export function updateCollectorLanguageMappings(params) {
  return (dispatch) => {
    const p = callApi('me/collector-languages', 'PUT', params);
    p.then(
      mappings => dispatch({ type: FETCH_COLLECTOR_LANGUAGE_MAPPINGS, mappings, errors: null }),
      errors => dispatch({ type: FETCH_COLLECTOR_LANGUAGE_MAPPINGS, mappings: [], errors }),
    );
    return p;
  };
}


export function updateAnnualSalesGoal(params) {
  return (dispatch) => {
    const p = callApi('me/annual-sales-goal', 'PUT', params);
    p.then(
      ({ user }) => dispatch(login(user)),
      () => {},
    );
    return p;
  };
}


export function updateSalesManager(params) {
  return (dispatch) => {
    const p = callApi('me/sales-manager', 'PUT', params);
    p.then(
      ({ user }) => dispatch(login(user)),
      () => {},
    );
    return p;
  };
}

export function updateEmailAlertSubscription(userId, params) {
  return (dispatch) => callApi(`users/${userId}/email-alert/subscription`, 'PUT', params)
    .then(
      (data) => {
        const { user } = data;
        dispatch({
          type: UPDATE_EMAIL_ALERT_SUBSCRIPTION,
          user,
        });
        return user;
      },
      () => {
        console.error('Failed to update email alert subscription');
      },
    );
}

export function getOrganizationSyncProcess(orgId) {
  return (dispatch) => {
    const p = callApi(`organizations/${orgId}/sync-process`, 'GET');
    return p;
  };
}